import fetch from "../auth/FetchInterceptor";
const AuthService = {};

AuthService.login = function (data, type) {
  const url = type === "club" ? "api/club/login" : "api/agent/login";
  return fetch({
    url: url,
    method: "post",
    data: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

AuthService.register = function (data) {
  return fetch({
    url: "api/club/register",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

AuthService.registerAgent = function (data) {
  return fetch({
    url: "api/agent/register",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
AuthService.forgotPasswordClub = function (email) {
  return fetch({
    url: "api/club/forgetPassword",
    method: "post",
    data: JSON.stringify({ email }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

AuthService.forgotPasswordAgent = function (email) {
  return fetch({
    url: "api/agent/forgetPassword",
    method: "post",
    data: JSON.stringify({ email }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
AuthService.resetPasswordAgent = function (data) {
  return fetch({
    url: "api/agent/resetPassword",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
AuthService.resetPasswordClub = function (data) {
  return fetch({
    url: "api/club/resetPassword",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export default AuthService;
